import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Offers } from '@dgx-pr-spa/shared/util';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OfferBackendService } from '@view-offers/services/offer-backend.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { of } from 'rxjs';
import {
  catchError,
  filter,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import * as fromOffers from '../actions/offers.action';

@Injectable()
export class OffersEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly viewOffersService: ViewOffersService,
    private readonly offerBackend: OfferBackendService,
    private readonly router: Router,
    public readonly buildConfigService: BuildConfigService
  ) {}
  isRedirected = false;
  loadOffer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromOffers.loadOffers),
      withLatestFrom(this.viewOffersService.offersState$),
      filter(([, state]) => !state.loaded),
      map(([action]) => action.payload),
      tap((prRef) => {
        if (!prRef) {
          const onMaintenancePage = this.router.url.includes('maintenance');
          if (this.isRedirected || onMaintenancePage) {
            return;
          }
          this.router.navigate(['/offer-not-found'], {
            replaceUrl: true,
          });
        } else {
          this.viewOffersService.setOfferReference(prRef);
        }
      }),
      filter((prRef) => !!prRef),
      switchMap((prRef) =>
        this.offerBackend
          .fetchOffers(`${this.buildConfigService.config.pr}/v2/offers`, {
            offer_reference: `${prRef}`,
          })
          .pipe(
            map((response: Offers) => {
              // if (prRef !== response.offer.offer_reference) {
              //   window.location.href = `/tips?PRRef=${response.offer.offer_reference}`;
              // }

              return fromOffers.loadOffersSuccess({
                payload: response,
              });
            }),
            catchError((error) => {
              if (error.error.status === 'OrderFailedPaymentTaken') {
                this.router.navigate(['/offer-error'], {
                  replaceUrl: true,
                  queryParams: {
                    plan_number: error.error.metaData.plan_number,
                  },
                });
                this.isRedirected = true;
              }
              return of(fromOffers.loadOffersFail(error));
            })
          )
      )
    )
  );
}
